import React, { useEffect, useState } from 'react'
import Breadcrumb from 'components/commercetools-ui/atoms/breadcrumb';
import { HomeIcon } from '@heroicons/react/24/outline';
import { ChevronRightIcon } from '@heroicons/react/24/solid';
import Link from 'components/commercetools-ui/atoms/link';
import SectionWithBanner from 'components/commercetools-ui/atoms/section-with-banner';
import ImageTextContent from 'components/commercetools-ui/atoms/image-text-content';
import { useFormat } from 'helpers/hooks/useFormat';
import dynamic from 'next/dynamic';
import usePath from 'helpers/hooks/usePath';
import WhiteOverlay from 'components/commercetools-ui/atoms/overlay/white-overlay';
import useMediaQuery from 'helpers/hooks/useMediaQuery';
import { hugeDesktop, largeDesktop, mediumDesktop, semiLargeDesktop } from 'helpers/utils/screensizes';

const Markdown = dynamic(() => import('../../organisms/markdown'));
export interface RenovationGuideProps {
    data: any;
    image: any;
}

const RenovationGuidePage: React.FC<RenovationGuideProps> = ({ data }) => {
  const { path } = usePath();
  const { formatMessage } = useFormat({ name: 'common' });
  const [loading, setLoading] = useState(true);

  const [isHugeDesktopSize] = useMediaQuery(hugeDesktop);
  const [isSemiLargeDesktopSize] = useMediaQuery(semiLargeDesktop);
  const [ismediumDesktopSize] = useMediaQuery(mediumDesktop);
  const [isLargeDesktopSize] = useMediaQuery(largeDesktop);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 2000); 
  }, []);

  return (
    <>
      {loading && <WhiteOverlay />}
      <div className="hidden px-24 pb-8 pt-16 md:block md:px-12  lg:px-32 xl:px-44 2xl:px-64">
        <Breadcrumb Separator={<ChevronRightIcon className="mt-2 w-16" />} listClassName="!gap-x-16">
          <Link link={'/'}>
            <HomeIcon className="mt-6 w-20" />
          </Link>
          <span className="text-14 font-normal capitalize leading-4 text-[#666]">Design & Planning</span>
          <span className="text-14 font-normal capitalize leading-4 text-[#666]">Renovation Guides</span>
        </Breadcrumb> 
      </div> 
      <div className="w-full flex flex-col">
        {data?.sections?.map((component: any, index: number) => (
          <div key={index}>
            {component?.section_with_image_text && (
              <div className="">
                <ImageTextContent data={component?.section_with_image_text} index={index} totalSections={data?.components?.length} />
              </div>
            )}

            {component?.section_with_video && (
              <div className="video-container flex justify-center md:px-100 lg:py-85 2xl:px-208 ">
                    <iframe
                        src={component?.section_with_video?.video_link?.href}
                        width="100%"
                        loading="lazy"
                        height={
                          isHugeDesktopSize ? '720px' :
                          isSemiLargeDesktopSize ? '480px' :
                          ismediumDesktopSize ? '500px' :
                          isLargeDesktopSize ? '600px' :
                          '320px'
                        }
                    ></iframe>
              </div>
            )}

            {component?.section_with_banner && (
              <div className="2xl:pt-68 xl:pt-68 pt-32">
                <SectionWithBanner data={component?.section_with_banner}  />
              </div>
            )}

            {component?.section_with_title_and_description && (
              <div className="">
                <div className="">
                <div className={`w-[min(100%,47rem)] ${index === 1 ? '2xl:text-40 xl:text-30 text-24' : 'text-24'} m-auto title font-medium leading-10 text-primary-black lg:border-none pt-40 pb-12 2xl:pt-80 2xl:pb-12 `}>
                  {component.section_with_title_and_description.title}
                  </div>
                <Markdown
                  className= {`${index == 1 && component.section_with_title_and_description.description.includes('<img') ? 'w-[min(100%,47rem)] m-auto' : ''}text-[#333333] mardown-container font-normal [&>p]:pt-12  ![&>figure>div>figcaption]:text-left 
                  [&>p]:w-[min(100%,47rem)] [&>ul]:w-[min(100%,47rem)] [&>ul]:m-auto [&>ol]:w-[min(100%,47rem)] [&>ol]:m-auto [&>figure>div>figcaption]:w-[min(100%,47rem)]  [&>ul>li] [&>figure>div>figcaption]:m-auto [&>p]:m-auto [&>ul]:list-disc [&>ul>li]:my-10  [&>ul>li>p>a]:!text-[#337ab7] [&>p>a]:!text-[#337ab7] [&>a]:!text-[#337ab7] text-14 md:text-16 2xl:text-18`}
                  markdown={component.section_with_title_and_description.description}
                />
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </>
  );
};

export default RenovationGuidePage;